module.exports = __webpack_public_path__ + "img/406ce8d.jpg";